import React, { useEffect, useRef, useState } from 'react';
import { Form, SubmitButton, useForm } from '../../../_lib/Form2';
import { ColorChooser } from '../../../_lib/Form2/elements/ColorChooser/ColorChooser';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { asFetchableView } from '../../../_lib/ViewFetcher';

const DocumentIDs = {
  highlightColor: '--highlight-color',
};

function ThemeColorEdit({ form }: any) {
  const { t } = useSonTranslation('ThemeColorForm');
  const [changedHighlightColor, setChangedHighlightColor] = useState<boolean>();

  const hilightColor = useRef<string>(null);

  /**
   * 2 ways to set the color:
   * 1. changing the preview only, for browsers that dont support custom properties
   * 2. changing the global property for the others
   */
  const setHighlightColor = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.validity.patternMismatch) {
      const colorPreview = document.getElementById(DocumentIDs.highlightColor);
      const color = event.target.value;
      if (colorPreview) {
        colorPreview.style.setProperty('background-color', color);
      }
      // changing highlight color live
      document.documentElement.style.setProperty(DocumentIDs.highlightColor, color);
    }
  };

  useEffect(() => {
    // read the initial color var
    hilightColor.current = document.documentElement.style.getPropertyValue(DocumentIDs.highlightColor);

    return () => {
      if (!changedHighlightColor && hilightColor.current) {
        // change preview color back to initial color if user didn't save changes
        document.documentElement.style.setProperty(DocumentIDs.highlightColor, hilightColor.current);
      }
    };
  }, [changedHighlightColor]);

  const { params, formProps, fetchState } = useForm({ form, onSuccess: () => setChangedHighlightColor(true) });
  const sonPortalHighlightColor = params.getByName('son_portal_theme_highlight_color');

  return (
    <Form id="theme-color-edit-view-form" {...formProps}>
      <ColorChooser
        param={sonPortalHighlightColor}
        label={t('edit.inputs.son_portal_theme_highlightColor.label')}
        onChange={e => setHighlightColor(e)}
      />
      <SubmitButton
        buttonLabel={t(`edit.button`)}
        messageSuccess={t('Form:status.success')}
        messageSending={t('Form:status.sending')}
        messageFail={t('Form:status.fail')}
        fetchState={fetchState}
        active={fetchState.type !== 'success' && fetchState.type !== 'error'}
      />
    </Form>
  );
}

export const ThemeColorEditView = asFetchableView(ThemeColorEdit);
